<template>
  <div class="content">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <select class="form-control" v-model="property" v-bind:disabled="properties.length <= 1" @change="$router.push({'name': $i18n.locale + 'ListPrices',  params: { property: property.slug } })">
            <option v-for="(property, index) in properties" v-bind:value="property">{{property.name}}</option>
          </select>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-clean table-vcenter" style="width:100%;">
            <thead>
              <tr>
                <th width="20%" class="text-nowrap">{{ $t('room') }}</th>
                <th width="50%" class="text-nowrap">{{ $t('title') }}</th>
                <th width="10%" class="text-nowrap">{{ $t('valid.from') }}</th>
                <th width="10%" class="text-nowrap">{{ $t('valid.until') }}</th>
                <th width="10%" class="text-nowrap">{{ $t('price') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr role="button" v-for="price in pagination.prices" @click="$router.push({ name: $i18n.locale + 'UpdatePrice', params: { price: price._id }  })">
                <td>{{ roomName(price.room) }}</td>
                <td>{{ price.title }}</td>
                <td>{{ price.valid.from | date }}</td>
                <td>{{ price.valid.until | date}}</td>
                <td>{{ price.price }}€</td>
              </tr>
            </tbody>
          </table>
        </div>

        <router-link v-bind:to="{ 'name': $i18n.locale + 'CreatePrice' }">
          {{ $t('create') }}
        </router-link>


        <div class="dataTables_wrapper">
          <div class="row">
            <div class="col-sm-12 col-md-5">
              <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
                {{ $t('showing') }}
                {{ pagination.first }}
                <span v-if="pagination.prices.length">
                  {{ $t('to') }} {{ pagination.first + pagination.prices.length - 1 }}
                </span>
                {{ $t('of') }}
                {{ pagination.total }}
                {{ $t('entries') }}
              </div>
            </div>
            <div class="col-sm-12 col-md-7">
              <pagination v-bind:pages="pagination.pages"></pagination>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';
import io from 'socket.io-client';

import moment from 'moment';

export default {
  name: 'PriceList',
  components:{
    Pagination
  },
  data: () => ({
    pagination: {
      prices: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {},
    properties: []
  }),
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    }
  },
  created(){

    const propSlug = this.$route.params.property;
    this.properties = this.$store.state.host.properties;
    this.property = this.properties.find(p => p.slug == propSlug);

    this.loadPrices();
  },
  methods: {
    loadPrices: function(){

      let url = '/prices?property._id=' + this.property._id;

      const page = this.$route.query.page || 1;
      const roomSlug = this.$route.params.room;

      if(roomSlug){
        url += '&roomSlug=' + roomSlug;
      }

      const checkInStart = this.$route.query.checkInStart;
      if(checkInStart){
        url += '&checkInStart=' + checkInStart;
      }

      const checkInEnd = this.$route.query.checkInEnd;
      if(checkInEnd){
        url += '&checkInEnd=' + checkInEnd;
      }

      const checkOutStart = this.$route.query.checkOutStart;
      if(checkOutStart){
        url += '&checkOutStart=' + checkOutStart;
      }

      const checkOutEnd = this.$route.query.checkOutEnd;
      if(checkOutEnd){
        url += '&checkOutEnd=' + checkOutEnd;
      }

      const search= this.$route.query.search;
      if(search){
        url += '&search=' + search;
      }

      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log(result);
        if(!result.error){
          return this.pagination = result;
          console.log(this.pagination);
        }
      })
    },
    roomName: function(room){
      console.log(room);
      console.log(this.property.rooms);
      let r = this.property.rooms.find(r => r._id == room._id);
      if(r) return r.name;
      return "";
    },
  }
};
</script>

<i18n>
{
  "en": {
    "prices": "prices",
    "room": "Room type",
    "title": "Title",
    "valid": {
      "from": "Valid from",
      "until": "Valid until"
    },
    "price": "Price",
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "entries": "entries",
    "create": "Create new Price"
  },
  "sl": {
    "prices": "cene",
    "room": "Tip sobe",
    "title": "Naziv",
    "valid": {
      "from": "Veljavno od",
      "until": "Veljavno do"
    },
    "price": "Cena",
    "showing": "Prikazanih",
    "to": "do",
    "of": "od",
    "entries": "vnosov",
    "create": "Ustvari novo ceno"
  }
}
</i18n>
